import { render, staticRenderFns } from "./DialogId10.vue?vue&type=template&id=0ac3b8b3&scoped=true&"
import script from "./DialogId10.vue?vue&type=script&lang=js&"
export * from "./DialogId10.vue?vue&type=script&lang=js&"
import style0 from "./DialogId10.vue?vue&type=style&index=0&id=0ac3b8b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac3b8b3",
  null
  
)

export default component.exports